// Shows the web page an AI-filled value was read from, e.g. the company's imprint
const FieldSource = ({ t, url }) => {
    if (!url) {
        return null;
    }

    let host = url;
    try {
        host = new URL(url).hostname.replace(/^www\./, '');
    } catch {
        // Not a full URL: show it as it is
    }

    return (
        <small className="text-muted d-block mt-1 ai-field-source">
            {t('Source')}:{' '}
            <a href={url} target="_blank" rel="noopener noreferrer">
                {host}
            </a>
        </small>
    );
};

export default FieldSource;
